import React from "react";

export default function CustomSelector({
  label,
  touched,
  error,
  name,
  onChange,
  onBlur,
  defaultValue,
  options,
  value,
}) {
  return (
    <div className="common-modal-field">
      <label>{label}</label>
      <select
        name={name}
        className="form-select"
        onChange={onChange}
        onBlur={onBlur}
        value={value}
      >
        <option value="" selected disabled hidden>
          {defaultValue}
        </option>
        {options.map((item) => {
          return <option value={item}>{item}</option>;
        })}
      </select>
      {touched && error && (
        <p style={{ color: "red", marginBottom: 0 }}>{error}</p>
      )}
    </div>
  );
}
